export enum ImportStatus {
  completed = 'Completed',
  completedWithErrors = 'Completed with errors',
  cancelled = 'Cancelled',
  failed = 'Failed',
  loading = 'In progress',
}
